import { useDisclosure } from '@chakra-ui/react';
import classNames from 'classnames';

import styles from './sankey-chart.module.css';
import { SankeyPathTooltip } from './sankey-path-tooltip';
import type { LinkPath } from './types';

type SankeyPathProps = {
  link: LinkPath;
  isOutflows: boolean;
  color?: string;
};

export const SankeyPath = ({
  link,
  isOutflows,
  color = '#5CA9E9',
}: SankeyPathProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <path
        d={link.path}
        fill="none"
        stroke={color}
        strokeWidth={link?.width}
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
        className={classNames(styles.path, {
          [styles.pathHover ?? '']: color === '#5ca9e9',
        })}
        data-testid="sankey-chart__path"
      />
      <SankeyPathTooltip d={link} isOpen={isOpen} isOutflows={isOutflows}>
        <circle
          r={0}
          cx={(link.target.x1 + link.source.x0) / 2}
          cy={(link.y1 + link.y0) / 2}
        />
      </SankeyPathTooltip>
    </>
  );
};
